import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Image,
  Row,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import {
  AngleRight,
  ContractsIcon,
  DeleteIcon,
  NeedHelp,
  PlusIcon,
} from "../../../../atoms/CustomIcons";
import DashboardTemplate from "../../../../templates/Dashboard";
import Dashboard from "./ProfileTabs/Dashboard";
import Services from "./ProfileTabs/Services";
import WorkOrders from "./ProfileTabs/WorkOrders";
import ProfileSidebar from "./Components/Sidebar";
import { useState } from "react";
import Invoices from "../../../Properties/Profile/ProfileTabs/Invoices";
import { MoreOutlined } from "@ant-design/icons";
import Dropdown from "antd/es/dropdown/dropdown";

export default function SubsProfile() {
  const [fullWidth, setFullWidth] = useState(false);

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <Dashboard />,
    },
    {
      key: "2",
      label: "Services",
      children: <Services />,
    },
    {
      key: "3",
      label: "Work orders",
      children: <WorkOrders />,
    },

    {
      key: "4",
      label: "Invoices",
      children: <Invoices />,
      disabled: true,
    },
  ];

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<PlusIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Add property
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Archive
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];
  return (
    <>
      <DashboardTemplate loading={false}>
        <div className="profileHeader">
          <div className="headerLeft">
            <Breadcrumb
              separator={<AngleRight />}
              style={{ marginBottom: "12px" }}
            >
              <Breadcrumb.Item>
                <a href={`/subs/${companyId}`}> Crews & Subs </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Subcontractor profile</Breadcrumb.Item>
            </Breadcrumb>

            <div className="headerContentWithImage">
              <Avatar
                size={74}
                className="avatarColor"
                shape="square"
                src="/images/work-orders/sub_profile_img.svg"
                style={{ borderRadius: "100px" }}
              />

              <div>
                <h2
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  Green Edge Landscapes
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <Tag> Low cost </Tag>
                  </span>
                </h2>

                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src="/images/estimate/pin_location.svg"
                      style={{ width: "16px", height: "16px" }}
                      preview={false}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#474C4D",
                      }}
                    >
                      1234 Templecliff Dr, Dallas, TX, 75217
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="headerRight" style={{ marginTop: 32 }}>
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              style={{ marginRight: "8px" }}
            >
              Notes & activity
            </Button>

            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
              className="actionButton"
            >
              <Button
                onClick={(x) => {
                  x.stopPropagation();
                }}
                onKeyDown={(e) => e.stopPropagation()}
                style={{
                  padding: "0px",
                  height: "36px",
                  width: "36px",
                  backgroundColor: "transparent",
                  border: "1px solid #DEE5E6",
                  borderRadius: "8px",
                }}
                className="only_icon"
                icon={<MoreOutlined />}
              />
            </Dropdown>
          </div>

          <div className="two_btns">
            <Button htmlType="submit" size="large" className="btn-sm">
              <NeedHelp /> Need help?
            </Button>
          </div>
        </div>

        <div className="profileContent">
          <Row gutter={[16, 16]} wrap={false}>
            <Col flex="auto" className="TabsArea">
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                className="profileTabs"
                tabBarExtraContent={
                  <Button
                    className="only_icon"
                    style={{ marginLeft: 8 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={
                      <Image
                        preview={false}
                        src="/images/profile/profile-fullWidth.svg"
                      />
                    }
                  />
                }
              />
            </Col>
            <Col
              flex={fullWidth ? "46px" : "360px"}
              className="rightSideBar"
              style={{ transition: "0.35s" }}
            >
              {fullWidth ? (
                <div className="fullWidthIconWrapper">
                  <Button
                    className="only_icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={<ContractsIcon />}
                  />
                </div>
              ) : (
                <ProfileSidebar />
              )}
            </Col>
          </Row>
        </div>
      </DashboardTemplate>
    </>
  );
}
